import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Checkbox,
  FormControlLabel
} from "@mui/material";

import { ReactComponent as CloseIcon } from "assets/img/svg/CrossIcon.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import styles from "./processCard.module.scss";
import { fetchBusByPid, sapPosting } from "./utils";
import ALoader from "views/pages/manage/common/a-loader";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

const SapPostingDialog = ({ open, onClose, getCommissionReports, processDetails, businessAreas }) => {

  const [remarks, setRemarks] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setRemarks("")
    setIsChecked(false);
    onClose()
  }

  const isApproveDisabled = () => {
    return !(remarks.trim() !== "" && isChecked);
  };

  const handleApprove = async () => {
    try {
      setLoading(true);
      const buList = await fetchBusByPid(processDetails?.id);
      const filterBuList = businessAreas.filter(item => buList.includes(item?.label))
      const payload = {
        processId: processDetails?.id,
        startDate: processDetails?.startDate,
        endDate: processDetails?.endDate,
        remarks: remarks,
        businessAreas: filterBuList.map((item) => ({
          businessArea: item.label,
          businessAreaId: item.businessAreaId
        }))
      }

      console.log("Approve Payload:", payload);

      const res = await sapPosting(payload);
      if (res?.code == 200) {
        successToast(res?.message)
        getCommissionReports({})
        handleClose();
      }
    }
    catch (err) {
      console.error(err);
    }
    finally {
      setLoading(false);
    }
  };

  return (<>
    {loading && <ALoader position={'fixed'} />}
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: "720px", borderRadius: "12px" }
      }}
    >


      <div className="d-flex align-items-center justify-content-between px-4 pt-3">

        <div className="large-text color-dark">
          Add remarks
        </div>

        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>

      </div>

      <DialogContent>


        <textarea
          className={styles.remarksTextarea}
          placeholder="Enter remarks"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />

{/* 
        <div className={styles.warningBox}>
          In case of any fraud/mismatch in the document. Please remove the
          student from list.
        </div> */}


        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
          }
          label="I have verified all information and confirm that the data is accurate for SAP posting."
          sx={{
            marginTop: "10px",
            '& .MuiFormControlLabel-label': {
              fontSize: "14px"
            }
          }}
        />


        <div className="mt-3">

          <AButton
            variant="primary_filled"
            disabled={isApproveDisabled()}
            onClick={handleApprove}
            fullWidth
          >
            Confirm approve
          </AButton>

        </div>

      </DialogContent>

    </Dialog>
  </>

  );
};

export default SapPostingDialog;